import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { DeviceService } from '../services/device.service';

@Injectable({
  providedIn: 'root',
})
export class LandingGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private deviceService: DeviceService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.user.pipe(
      take(1),
      map((user) => {
        const isMobileDevice = this.deviceService.isMobileDevice();

        if (!isMobileDevice) {
          return this.router.createUrlTree(['/overview']);
        }

        if (user?.isMobile) {
          return this.router.createUrlTree(['/mobile']);
        }

        return this.router.createUrlTree(['/working-day']);
      })
    );
  }
}
